import React from "react";
// import { Link } from "react-router-dom";
import styles from "./IconList.module.sass";
import Icon from "../../components/Icon";
import { icons } from "../../components/Icon";

const IconList = () => {

    return (
        <div className={styles.page}>
            {Object.keys(icons).map((icon) => (
                <div className={styles.row}>
                    <span className={styles.icon}>
                        <Icon name={icon} size="24" />
                    </span>
                    <span className={styles.name}>
                        {icon}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default IconList;
